/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/wearables'
export default icon
